module.exports = __webpack_public_path__ + "img/70.99995ac7.svg";